import { defineStore } from 'pinia'
import {ArticleService} from "@/services/article.service";
import {GalleryService} from "@/services/gallery.service";
const articleService = new ArticleService();
const galleryService = new GalleryService();
const size = +localStorage.getItem('size');
const style = localStorage.getItem('style');
const v = JSON.parse(localStorage.getItem('version'));
export const useCounterStore = defineStore('counter', {
  state: () => ({
    mediaList: [],
    legislationList: [],
    decreesList: [],
    resolutionList: [],
    photoList: [],
    stateList: [],
    orderList: [],
    competitionsList: [],
    articleList: [],
    vacanciesList: [],
    governmentList: [],
    fontSize: size ?? 16,
    mainStyle: style ?? 'default-theme',
    version: v ?? false,
    mainData: null
  }),

  actions: {
    setFontSize (value) {
      this.fontSize = value;
    },
    setMainStyle (value) {
      this.mainStyle = value
    },
    setMainData (obj) {
      this.mainData = obj;
    },
    async setMediaList (page, size) {
      await articleService.getPublished(1, page, size).then((res) => {
        this.articleList = res.page;
      })
    },
    async setLegislation (page, size) {
      await articleService.getPublished(2, page, size).then((res) => {
        this.articleList = res.page;
      })
    },
    async setDecrees (page, size) {
      await articleService.getPublished(3, page, size).then((res) => {
        this.articleList = res.page;
      })
    },
    async setResolution (page, size) {
      await articleService.getPublished(4, page, size).then((res) => {
        this.articleList = res.page;
      })
    },
    async setGovDecrees (page, size) {
      await articleService.getPublished(5, page, size).then((res) => {
        this.articleList = res.page;
      })
    },
    async setStateList (page, size) {
      await articleService.getPublished(6, page, size).then((res) => {
        this.articleList = res.page;
      })
    },
    async setOrderList (page, size) {
      await articleService.getPublished(7, page, size).then((res) => {
        this.articleList = res.page;
      })
    },
    async setRegulations (page, size) {
      await articleService.getPublished(8, page, size).then((res) => {
        this.articleList = res.page;
      })
    },
    async setCorruption (page, size) {
      await articleService.getPublished(9, page, size).then((res) => {
        this.articleList = res.page;
      })
    },
    async setPropertyRelation (page, size) {
      await articleService.getPublished(10, page, size).then((res) => {
        this.articleList = res.page;
      })
    },
    async setVacancies (page, size) {
      await articleService.getPublished(12, page, size).then((res) => {
        this.vacanciesList = res.page;
      })
    },
    async setPhotoList (page, size) {
      await galleryService.getPhotoGallery(page, size).then((res) => {
        this.photoList = res.page;
      })
    },
  },
})
